<template lang="pug">
.options
	.backdrop
	.close(@click="close()") ×
	.content
		.pagetitle {{overlaydata.title}}
		.selection-list
			.selection-entry(v-for="option in overlaydata.options" @click="callAction(option)") {{option.value}}
</template>

<script>
export default {
  props: ['overlaydata'],
  methods: {
    close() {
      this.$store.commit('openOverlay', '');
    },
    callAction(option) {
      option.action();
      this.close();
    },
  },
};
</script>

<style lang="sass" scoped>
.options
	height: 100vh
	width: 100%
	background-image: url(../../assets/splash.png)
	display: flex
	flex-direction: column
	align-items: center
	color: #fff
	padding: 0 20px
	position: fixed
	max-width: 480px
	margin: 0 auto
	right: 0
	top: 0
	left: 0
	z-index: 4
.backdrop
	background-color: rgba(0, 0, 0, .9)
	width: 100%
	height: 100vh
	position: absolute
	z-index: 6
.close
	position: absolute
	right: 20px
	top: 20px
	background-color: #fff
	z-index: 9
	color: #1DB2D1
	width: 20px
	height: 20px
	display: flex
	justify-content: center
	align-items: center
	border-radius: 20px
.content
	width: 100%
	height: 100vh
	z-index: 7
	display: flex
	flex-direction: column
	align-items: center
	justify-content: center
.pagetitle
	font-size: 1.85rem
	text-align: center
.selection
	&-list
		width: 100%
		font-size: 20px
		margin-top: 20px
	&-entry
		padding: 20px 0
		text-align: center
		& + .selection-entry
			border-top: 1px solid #fff
</style>
